import type { SearchType } from "@/react/components/search/types";

const SPOTLIGHT_SEARCH_PARAM = "search";
const SPOTLIGHT_QUERY_PARAM = "q";
const SPOTLIGHT_TAB_PARAM = "search_tab";

const SPOTLIGHT_OPEN_VALUE = "open";

const SEARCH_TABS: SearchType[] = [
  "posts",
  "comments",
  "messages",
  "lessons",
  "events",
  "members",
];

export interface SpotlightSearchUrlState {
  isOpen: boolean;
  query: string | null;
  tab: SearchType | null;
}

export const readSpotlightSearchParams = (
  search: string,
): SpotlightSearchUrlState => {
  const params = new URLSearchParams(search);
  const query = params.get(SPOTLIGHT_QUERY_PARAM);
  const tabParam = params.get(SPOTLIGHT_TAB_PARAM);
  const tab = SEARCH_TABS.includes(tabParam as SearchType)
    ? (tabParam as SearchType)
    : null;

  return {
    isOpen:
      params.get(SPOTLIGHT_SEARCH_PARAM) === SPOTLIGHT_OPEN_VALUE ||
      query !== null,
    query,
    tab,
  };
};

interface BuildParams {
  query?: string | null;
  tab?: SearchType | null;
}

export const buildSpotlightSearch = (
  currentSearch: string,
  { query, tab }: BuildParams,
): string => {
  const params = new URLSearchParams(currentSearch);

  params.set(SPOTLIGHT_SEARCH_PARAM, SPOTLIGHT_OPEN_VALUE);

  if (query) {
    params.set(SPOTLIGHT_QUERY_PARAM, query);
  } else {
    params.delete(SPOTLIGHT_QUERY_PARAM);
  }

  if (query && tab) {
    params.set(SPOTLIGHT_TAB_PARAM, tab);
  } else {
    params.delete(SPOTLIGHT_TAB_PARAM);
  }

  return params.toString();
};

export const clearSpotlightSearch = (currentSearch: string): string => {
  const params = new URLSearchParams(currentSearch);
  params.delete(SPOTLIGHT_SEARCH_PARAM);
  params.delete(SPOTLIGHT_QUERY_PARAM);
  params.delete(SPOTLIGHT_TAB_PARAM);
  return params.toString();
};
